import { AlertCircle, ArrowRight, CheckCircle2, Clock3, RotateCcw } from "lucide-react";
import { useEffect, useMemo, useState } from "react";
import { Link } from "react-router-dom";
import { money } from "../../shared/domain";
import type { ActivitySnapshot, Credit } from "../../shared/types";
import { Spinner } from "../components/Spinner";
import { api } from "../lib/api";

function statusIcon(status: Credit["status"]) {
  if (status === "available") return <CheckCircle2 />;
  if (status === "pending") return <Clock3 />;
  return <RotateCcw />;
}

export function ActivityPage() {
  const [activity, setActivity] = useState<ActivitySnapshot>();
  const [error, setError] = useState("");
  useEffect(() => { void api.activity().then(setActivity).catch((reason) => setError(reason instanceof Error ? reason.message : String(reason))); }, []);
  const uncredited = useMemo(() => activity?.attempts.filter((attempt) => !activity.credits.some((credit) => credit.attemptId === attempt.id)) || [], [activity]);
  if (!activity && !error) return <Spinner label="Loading activity" />;
  return (
    <div className="activity-page page-width">
      <header className="page-title"><p className="eyebrow">YOUR BUCKS</p><h1>Activity</h1><p>Every attempt and reward, in plain language.</p></header>
      {error && <div className="form-error">{error}</div>}
      {!activity?.credits.length && !uncredited.length ? (
        <section className="empty-panel"><Clock3 /><h2>Your activity starts here.</h2><p>Started offers and confirmed rewards will appear here.</p><Link className="button" to="/earn">Find an offer<ArrowRight /></Link></section>
      ) : (
        <>
          {Boolean(activity?.credits.length) && <section className="activity-list"><h2>Rewards</h2>{activity!.credits.map((credit) => (
            <article key={credit.id} className={`activity-row ${credit.status}`}>
              <span className="activity-icon">{statusIcon(credit.status)}</span>
              <div className="activity-main"><strong>{credit.title}</strong><span>{new Date(credit.createdAt).toLocaleDateString(undefined, { month: "short", day: "numeric", year: "numeric" })}</span></div>
              <div className="activity-value"><strong>{credit.status === "reversed" ? "−" : "+"}{money(credit.amountCents)}</strong><span>{credit.status === "available" ? "Earned" : credit.status}</span></div>
            </article>
          ))}</section>}
          {Boolean(uncredited.length) && <section className="activity-list"><h2>Started</h2>{uncredited.map((attempt) => (
            <article key={attempt.id} className="activity-row started">
              <span className="activity-icon"><AlertCircle /></span>
              <div className="activity-main"><strong>{attempt.offerTitle}</strong><span>Started {new Date(attempt.startedAt).toLocaleDateString()}</span></div>
              <div className="activity-actions"><Link to={`/support/missing-credit?attempt=${attempt.id}`}>Missing credit?</Link>{api.demo && <Link to={`/demo/complete/${attempt.id}`}>Continue</Link>}</div>
            </article>
          ))}</section>}
        </>
      )}
    </div>
  );
}
